import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stepForPath, trackStep } from "@/utils/attribution";

/**
 * Reports the launch funnel's three public steps as the signed-out visitor
 * moves between pages (utils/attribution.ts). Renders nothing.
 *
 * Signed-in people are never counted: the funnel is about arriving, and an
 * account holder opening the pricing page is not a new arrival.
 */
export function FunnelTracker({ signedIn }: { signedIn: boolean }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (signedIn) return;
    const step = stepForPath(pathname);
    if (step) trackStep(step);
  }, [pathname, signedIn]);

  return null;
}

export default FunnelTracker;
